webpackJsonp([112429270451854],{

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var status = function status(states) {
	  if (states.indexOf('loading') > -1) return { label: 'loading', color: '#c9821f' };
	  if (states.indexOf('success') > -1) return { label: 'success', color: '#1f7a4d' };
	  if (states.indexOf('failure') > -1) return { label: 'failure', color: '#b8352f' };
	  return { label: 'idle', color: '#4c5964' };
	};
	
	var FetchPanel = function FetchPanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      log = _ref.log,
	      onEvent = _ref.onEvent;
	
	  var states = configuration || [];
	  var current = status(states);
	  var attempts = datamodel && typeof datamodel.attempts !== 'undefined' ? datamodel.attempts : 0;
	  var message = datamodel && datamodel.message ? datamodel.message : 'Loading...';
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { background: current.color, color: '#fff', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'Fetch state'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: '2rem', lineHeight: '2.4rem' } },
	        current.label
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        message
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { background: '#fff', border: '1px solid #ddd', padding: '0.75rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Attempts'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        attempts
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-primary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('FETCH');
	          } },
	        'Fetch'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-success', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('RESOLVE');
	          } },
	        'Resolve'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-danger', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('REJECT');
	          } },
	        'Reject'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-secondary', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('RETRY');
	          } },
	        'Retry'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', style: { marginRight: '0.5rem', marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('CANCEL');
	          } },
	        'Cancel'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', style: { marginBottom: '0.5rem' }, onClick: function onClick() {
	            return onEvent('RESET');
	          } },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = FetchPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 907:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"idle\"\n       name=\"FetchExample\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"attempts\" expr=\"0\"/>\n    <data id=\"message\" expr=\"'Ready to fetch.'\"/>\n  </datamodel>\n\n  <state id=\"idle\">\n    <onentry>\n      <assign location=\"message\" expr=\"'Ready to fetch.'\"/>\n    </onentry>\n    <transition event=\"FETCH\" target=\"loading\">\n      <assign location=\"attempts\" expr=\"attempts + 1\"/>\n      <send event=\"trace\"><content expr=\"'Fetch requested.'\"/></send>\n    </transition>\n  </state>\n\n  <state id=\"loading\">\n    <onentry>\n      <assign location=\"message\" expr=\"'Loading remote data...'\"/>\n      <send event=\"trace\"><content expr=\"'Waiting for the async result.'\"/></send>\n    </onentry>\n    <transition event=\"RESOLVE\" target=\"success\">\n      <assign location=\"message\" expr=\"'Data loaded successfully.'\"/>\n    </transition>\n    <transition event=\"REJECT\" target=\"failure\">\n      <assign location=\"message\" expr=\"'Request failed.'\"/>\n    </transition>\n    <transition event=\"CANCEL\" target=\"idle\">\n      <assign location=\"message\" expr=\"'Fetch cancelled.'\"/>\n    </transition>\n  </state>\n\n  <state id=\"success\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Fetch resolved.'\"/></send>\n    </onentry>\n    <transition event=\"FETCH\" target=\"loading\">\n      <assign location=\"attempts\" expr=\"attempts + 1\"/>\n    </transition>\n    <transition event=\"RESET\" target=\"idle\">\n      <assign location=\"attempts\" expr=\"0\"/>\n    </transition>\n  </state>\n\n  <state id=\"failure\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'Fetch rejected.'\"/></send>\n    </onentry>\n    <transition event=\"RETRY\" target=\"loading\">\n      <assign location=\"attempts\" expr=\"attempts + 1\"/>\n    </transition>\n    <transition event=\"RESET\" target=\"idle\">\n      <assign location=\"attempts\" expr=\"0\"/>\n    </transition>\n  </state>\n</scxml>\n"

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fetchScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _fetchPanel = __webpack_require__(412);
	
	var _fetchPanel2 = _interopRequireDefault(_fetchPanel);
	
	var _fetch = __webpack_require__(907);
	
	var _fetch2 = _interopRequireDefault(_fetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.fetchScxml = _fetch2.default;
	
	var XStateFetchExample = function (_React$Component) {
	  _inherits(XStateFetchExample, _React$Component);
	
	  function XStateFetchExample(props) {
	    _classCallCheck(this, XStateFetchExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { log: [] };
	    return _this;
	  }
	
	  XStateFetchExample.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _scxml2.default.documentStringToModel(null, _fetch2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  XStateFetchExample.prototype.customSend = function customSend(event) {
	    if (event.name === 'trace') {
	      this.setState(function (_ref) {
	        var log = _ref.log;
	        return { log: log.concat(event.data).slice(-12) };
	      });
	    } else {
	      this.sc.gen(event);
	    }
	  };
	
	  XStateFetchExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  XStateFetchExample.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '520px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _fetch2.default,
	            disableAnimation: true,
	            disableZoom: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'xstate-fetch'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '520px', border: '1px solid #eee' } },
	          _react2.default.createElement(_fetchPanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this3.send(event);
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return XStateFetchExample;
	}(_react2.default.Component);
	
	exports.default = XStateFetchExample;

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _xstateFetchExample = __webpack_require__(413);
	
	var _xstateFetchExample2 = _interopRequireDefault(_xstateFetchExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var Fetch = function Fetch(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This ports the shape of Stately\'s XState simple fetch example into SCXML. The machine covers idle, loading, success, and failure states, with retry, cancel, and reset events exposed in the browser panel.'
	    ),
	    React.createElement(_xstateFetchExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _xstateFetchExample.fetchScxml
	    )
	  );
	};
	
	var WrappedFetch = function WrappedFetch(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: Fetch, pathname: location.pathname });
	};
	
	exports.default = WrappedFetch;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-fetch-js-96b07750f70b1ab37661.js